/* pmtsketch theme – kleines, abhängigkeitsfreies Script */
(function () {
  'use strict';

  /* Skizze-Haut-Regler und Umschalten zwischen Arbeiten */
  function initCompare(root) {
    (root || document).querySelectorAll('[data-compare-wrap]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var panels = wrap.querySelectorAll('[data-compare]');
      panels.forEach(function (panel) {
        var range = panel.querySelector('input[type="range"]');
        if (!range) return;
        var set = function () { panel.style.setProperty('--pos', range.value + '%'); };
        range.addEventListener('input', set);
        set();
      });
      var buttons = wrap.querySelectorAll('[data-compare-pick]');
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          panels.forEach(function (p, j) { p.hidden = j !== i; });
          buttons.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Sanftes Einblenden beim Scrollen */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Inhaltsverzeichnis aus den H2 eines Artikels */
  function slugify(text) {
    return text.toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }
  function initToc() {
    var toc = document.querySelector('[data-toc]');
    var prose = document.querySelector('[data-toc-source]');
    if (!toc || !prose) return;
    var heads = prose.querySelectorAll('h2');
    if (heads.length < 2) { toc.closest('[data-toc-wrap]').hidden = true; return; }
    var list = toc.querySelector('ol');
    var used = {};
    heads.forEach(function (h) {
      var id = h.id || slugify(h.textContent) || 'abschnitt';
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  /* Menge +/- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.dataset.step === 'up' ? v + 1 : Math.max(1, v - 1);
          input.value = v;
        });
      });
    });
  }

  /* Varianten-Auswahl */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    var json = document.querySelector('[data-product-json]');
    if (!form || !json) return;
    var variants = JSON.parse(json.textContent);
    var selects = form.querySelectorAll('[data-option]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var submit = form.querySelector('[type="submit"]');
    var money = form.dataset.moneyFormat || '{{amount}} €';
    function format(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return money.replace(/\{\{\s*\w+\s*\}\}/, amount);
    }
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) { submit.disabled = true; submit.textContent = submit.dataset.unavailable; return; }
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = format(match.price);
      submit.disabled = !match.available;
      submit.textContent = match.available ? submit.dataset.add : submit.dataset.soldout;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    initCompare();
    initReveal();
    initToc();
    initQty();
    initVariants();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme-Editor: neu geladene Sections wieder verdrahten */
  document.addEventListener('shopify:section:load', function (e) {
    initCompare(e.target);
    initReveal(e.target);
  });
})();
